import Component from '../core/Component'
import Bloodhound from 'bloodhound-js'
import throttle from 'lodash/throttle'
import { substitute, standardize } from '../utils/String'

export const STATES = {
    ACTIVE: 'is-active',
}

const defaults = {
    key: 'title',
    keys: null,
}

export default class Autocomplete extends Component {
    constructor(element, options = {}) {
        super(element, defaults)

        this.ref = {
            input: null,
            list: null,
            template: null,
        }

        this.options = options

        this.engine = null

        this.isReady = false
    }

    async prepare() {
        this.template = this.ref.template.textContent.trim()

        const bloodhoundOptions = {
            local: this.options.data,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
        }

        if (this.options.keys) {
            bloodhoundOptions.datumTokenizer = (datum) =>
                this.options.keys.map((key) => Bloodhound.tokenizers.whitespace(datum[key])).flat()
        } else {
            bloodhoundOptions.datumTokenizer = (datum) =>
                Bloodhound.tokenizers.whitespace(datum[this.options.key])
        }

        this.engine = new Bloodhound(bloodhoundOptions)

        await this.engine.initialize()
        this.ref.input.addEventListener('keyup', throttle(::this.handleKeyup, 100))
        this.ref.list.addEventListener('click', ::this.handleListClick)
    }

    handleKeyup(event) {
        this.engine.search(standardize(event.target.value), ::this.handleResults)
    }

    handleResults(results) {
        if (results.length) {
            this.ref.list.innerHTML = results
                .slice(0, 10)
                .map((item) => substitute(this.template, item))
                .join('')
            this.show()
        } else {
            this.hide()
        }
    }

    handleListClick(event) {
        const item = event.target.closest('[data-select]')

        if (item) {
            const data = item ? JSON.parse(item.dataset.select) : null
            this.ref.input.value = data.title
            this.emit('select', data)
            this.hide()
        }
    }

    show() {
        this.element.classList.add(STATES.ACTIVE)
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)
    }
}
